<button [ngClass]="buttonClass" (click)="customFunctiionName()"  type={{buttonType}}  [disabled]=buttonDisabled role=buttonRole id={{buttonId}}>
  @if (isIconVisible) {
    <span  [ngClass]="iconEleClass"></span>
  }
  @if (isTitleVisible) {
    <span [ngClass]="titleEleClass" >{{title | translate }} </span>
  }
</button>
